export const booleanFormatter = (v: unknown) => (v ? "Yes" : "No");
